module.exports = __webpack_public_path__ + "img/p1.380385e2.png";